import React from 'react';

function ReachOutSection() {
  return (
    <section className="reach-out-section">
      {/* Subtle dotted background */}
      <div className="reach-out-dotted-bg"></div>

      <div className="container reach-out-container">
        
        {/* Section Subtitle & Title */}
        <div className="reach-out-header">
          <div className="reach-out-subtitle">
            <span>Get in Touch</span>
            <span className="subtitle-line"></span>
          </div>
          <h2 className="reach-out-title">You can Reach Out to Us At</h2>
        </div>

        {/* 4 Info Cards Grid */}
        <div className="reach-out-cards-grid">
          
          {/* Card 1: Head Office */}
          <div className="reach-info-card">
            <div className="card-icon-box icon-red">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <h3 className="card-title">Head Office</h3>
            <p className="card-text">
              KDA Commercial Building,<br />
              Office # 03, Block-A, North<br />
              Nazimabad, Karachi
            </p>
          </div>

          {/* Card 2: Email Address */}
          <div className="reach-info-card">
            <div className="card-icon-box icon-dark">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
                <circle cx="17" cy="15" r="2.5" />
                <path d="M17 12.5a2.5 2.5 0 0 0 0 5" />
              </svg>
            </div>
            <h3 className="card-title">Email Address</h3>
            <p className="card-text">
              <a href="mailto:info@expertscommunication.net" className="card-link">
                info@expertscommunication.net
              </a>
            </p>
          </div>

          {/* Card 3: Telephone */}
          <div className="reach-info-card">
            <div className="card-icon-box icon-red">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <h3 className="card-title">Telephone</h3>
            <p className="card-text">
              <a href="tel:+923177770002" className="card-link">
                +92 (317) 777 0002
              </a>
            </p>
          </div>

          {/* Card 4: Office Hours */}
          <div className="reach-info-card">
            <div className="card-icon-box icon-dark">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h3 className="card-title">Office Hours</h3>
            <p className="card-text">
              Monday – Friday<br />
              (7 PM – 4 AM)
            </p>
          </div>

        </div>

        {/* Bottom Banner Row: Image + Red Consultation Card */}
        <div className="consultation-banner-grid">
          
          {/* Left Column Image (contact-moc1.jpg) */}
          <div className="consultation-img-wrapper">
            <img
              src="/assets/images/contact-moc1.jpg"
              alt="Get Free Consultation"
              className="consultation-img"
            />
          </div>

          {/* Right Column Red Card */}
          <div className="consultation-red-card">
            <div className="consultation-subtitle">
              <span>Send Us Your Inquiry</span>
              <span className="subtitle-line-white"></span>
            </div>
            <h2 className="consultation-title">Get Free Consultation</h2>
            <p className="consultation-desc">
              Fill out the form below, give us a call, or email us, and our experts will get back to you within 24 hours.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}

export default ReachOutSection;
